import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import type { RecordingFilters } from '@/app/module/reports/call-recordings-query'
import { ERROR_EXPORT_CALL_RECORDINGS, EXPORT_CALL_RECORDINGS_PENDING } from '@/app/module/reports/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useExportCallRecordings = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [createExport, result] = esApi.endpoints.downloadOrgRecordings.useMutation()

  const exportRecordings = useCallback(
    async ({ campid, userid, startDate, endDate }: RecordingFilters) => {
      if (!orgId) return undefined

      try {
        const response = await createExport({ orgId: String(orgId), campid, userid, startDate, endDate }).unwrap()
        dispatch(
          createNotification({
            'export-recordings-pending': { type: 'success', message: EXPORT_CALL_RECORDINGS_PENDING },
          }),
        )
        return response
      } catch (error) {
        dispatch(
          createNotification({
            'export-recordings-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_EXPORT_CALL_RECORDINGS),
            },
          }),
        )
        return undefined
      }
    },
    [orgId, createExport, dispatch],
  )

  return [exportRecordings, result] as const
}
